import React from 'react'

import { IconButton } from 'components/Button'
import Icon from 'components/Icon'
import urlGenerator from 'components/ReviewCard/components/ShareToolbox/urlGenerator'

import classes from './ShareToolbox.module.scss'

const SOCIAL_NETWORKS = [
  { name: 'linkedin', icon: ['fab', 'linkedin'], label: 'LinkedIn' },
  { name: 'twitter', icon: ['fab', 'x-twitter'], label: 'Twitter' },
  { name: 'facebook', icon: ['fab', 'facebook-square'], label: 'Facebook' },
]

const noop = () => {}

const handleButtonClick = ({ name, url, message, callback }) => {
  return event => callback(event, { name, url: urlGenerator({ name, url, message }) })
}

/** @type {import("./types").default} */
const ShareToolbox = ({ disabledButtons = {}, url, message, onButtonClick = noop }) => (
  <div className={classes.root} data-testid="review-card-social-icons">
    {SOCIAL_NETWORKS.map(({ name, label, icon }) => (
      <IconButton
        key={`social-link-${name}`}
        aria-label={`Share on ${label}`}
        className={classes.button}
        onClick={handleButtonClick({ name, url, message, callback: onButtonClick })}
        disabled={!!disabledButtons[name]}
      >
        <Icon icon={icon} />
      </IconButton>
    ))}
  </div>
)

export default ShareToolbox
